import http from '../../plugins/axios';

export default {

    rewardList(data) {
        return http.get({
            url: '/admin/hashrate/gainList',
            data
        })
    },

    createReward(data) {
        return http.post({
            url: '/admin/hashrate/createGain',
            data,
            dataType: 'form'
        })
    },
    deleteReward(data) {
        return http.post({
            url: '/admin/hashrate/deleteGain',
            data,
            dataType: 'form'
        })
    },
    grantReward(data) {
        return http.post({
            url: '/admin/hashrate/grantGain',
            data,
            dataType: 'form'
        })
    },
    updateHashrateConfig(data) {
        return http.post({
            url: '/admin/hashrate/updateHashrateConfig',
            data,
            dataType: 'form'
        })
    },
    hashrateConfig(data) {
        return http.get({
            url: '/admin/hashrate/hashrateConfig',
            data
        })
    },
    companyConfig(data) {
        return http.get({
            url: '/admin/hashrate/companyConfig',
            data
        })
    }

}